import { useEffect } from "react";

/**
 * Set page <title>, meta description and canonical URL for the current route.
 * Lightweight alternative to react-helmet — no extra dependency.
 *
 * Usage:
 *   useDocumentMeta({
 *     title: "Контакти · Konstantin Mobile",
 *     description: "...",
 *     path: "/contact",
 *   });
 */
const SITE_BASE = "https://konstantin-mobile.bg";

export default function useDocumentMeta({ title, description, path = "", image }) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (selector, value) => {
            if (!value) return;
            let el = document.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                const [, attr, val] = selector.match(/\[([^=]+)="([^"]+)"\]/) || [];
                if (attr && val) el.setAttribute(attr, val);
                document.head.appendChild(el);
            }
            el.setAttribute("content", value);
        };

        setMeta('meta[name="description"]', description);
        setMeta('meta[property="og:title"]', title);
        setMeta('meta[property="og:description"]', description);
        setMeta('meta[property="og:url"]', `${SITE_BASE}${path}`);
        setMeta('meta[name="twitter:title"]', title);
        setMeta('meta[name="twitter:description"]', description);
        if (image) {
            setMeta('meta[property="og:image"]', image);
            setMeta('meta[name="twitter:image"]', image);
        }

        // Canonical
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE_BASE}${path}`);
    }, [title, description, path, image]);
}
